
import React from 'react';
import { Button } from "@/components/ui/button";
import { Loader2, X } from "lucide-react";

interface OrderFormActionsProps {
  handleBackToOrders: () => void;
  isSubmitting: boolean;
  isEditing?: boolean;
  isValid?: boolean;
}

const OrderFormActions = ({
  handleBackToOrders,
  isSubmitting,
  isEditing = false,
  isValid = true
}: OrderFormActionsProps) => {
  console.log('OrderFormActions - rendering with isSubmitting:', isSubmitting, 'isValid:', isValid);
  
  return (
    <div className="mt-8 flex justify-end space-x-4">
      <Button 
        type="button" 
        variant="outline" 
        onClick={handleBackToOrders}
        disabled={isSubmitting}
        className="h-10 px-4 py-2 flex items-center"
      >
        <X className="mr-2 h-4 w-4" />
        Annuler
      </Button>
      <Button 
        type="submit"
        disabled={isSubmitting || !isValid}
        className={`reference-table-add-button bg-indigo-500 hover:bg-indigo-600 text-white px-5 py-2 rounded-md ${!isValid ? 'opacity-50 cursor-not-allowed' : ''}`}
        data-testid="create-order-submit-button"
      >
        {isSubmitting ? (
          <>
            <Loader2 className="mr-2 h-4 w-4 animate-spin" />
            Traitement...
          </>
        ) : (
          isEditing ? "Modifier la commande" : "Créer la commande"
        )}
      </Button>
    </div>
  );
};

export default OrderFormActions;
